import { authClient } from "@/lib/authClient";
import { RouteTable } from "@/lib/routes";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@repo/ui/components/Sidebar";
import { ChartNoAxesCombined, Database, Users as UsersIcon, type LucideIcon } from "lucide-react";
import { Link, matchPath, useLocation } from "react-router";

type NavItem = {
  title: string;
  url: string;
  icon: LucideIcon;
};

const items = {
  main: [
    {
      title: "Dashboard",
      url: RouteTable.dashboard(),
      icon: ChartNoAxesCombined,
    },
    {
      title: "Metabase",
      url: RouteTable.metabase(),
      icon: Database,
    },
  ] satisfies NavItem[],
  admin: [
    {
      title: "Users",
      url: RouteTable.users(),
      icon: UsersIcon,
    },
  ] satisfies NavItem[],
};

export function NavMain() {
  const { pathname } = useLocation();

  const { data: session, isPending } = authClient.useSession();

  if (isPending || !session) return null;

  const isActive = (item: NavItem) =>
    Boolean(matchPath({ path: item.url, end: item.url.length === 1 }, pathname));

  return (
    <>
      <SidebarGroup>
        <SidebarGroupLabel>Analytics</SidebarGroupLabel>
        <SidebarMenu>
          {items.main.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild tooltip={item.title} isActive={isActive(item)}>
                <Link to={item.url}>
                  <item.icon />
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroup>

      {session.user.role === "admin" && (
        <SidebarGroup className="mt-auto">
          <SidebarGroupLabel>Admin</SidebarGroupLabel>
          <SidebarMenu>
            {items.admin.map((item) => (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton asChild tooltip={item.title} isActive={isActive(item)}>
                  <Link to={item.url}>
                    <item.icon />
                    <span>{item.title}</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </SidebarGroup>
      )}
    </>
  );
}
